import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import DiariosExpo25 from '../../../components/diario/listar/expomacuco';


function DiariosExpo25Screen() {
    return (
        <Fragment>
            <Head titulo="Publicações da Expo Macuco 2025" />
            <Header />
            <Container>
                <DiariosExpo25 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiariosExpo25Screen;